import React, { useState } from 'react';
import './Auth.css';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { LoginButton } from '@telegram-auth/react';

function AuthLogin() {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Пароль должен содержать минимум 8 символов.");
      return;
    }

    try {
      const response = await fetch("api/users/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: name, password }),
      });

      const login_response = await response.json();

      if (login_response.ok) {
        setError("");
        localStorage.setItem("refresh_token", login_response.access_token);
        navigate("/courses");
      } else {
        setError(login_response.error_message || "Произошла ошибка. Попробуйте снова.");
      }
    } catch (error) {
      setError("Произошла ошибка сети. Попробуйте позже.");
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    const { credential } = credentialResponse;
    try {
      const response = await fetch("api/users/google-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: credential }),
      });

      const login_response = await response.json();

      if (login_response.ok) {
        setError("");
        localStorage.setItem("refresh_token", login_response.access_token);
        navigate("/courses");
      } else {
        setError(login_response.error_message || "Ошибка аутентификации через Google.");
      }
    } catch (error) {
      setError("Ошибка сети. Попробуйте позже.");
    }
  };

  const handleGoogleError = () => {
    setError("Не удалось войти через Google. Попробуйте снова.");
  };

  const handleTgSuccess = async (data) => {
    try {
      const response = await fetch("api/users/tg-login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const login_response = await response.json();

      if (login_response.ok) {
        localStorage.setItem("refresh_token", login_response.access_token);
        navigate("/courses");
      } else {
        setError(login_response.error_message || "Ошибка аутентификации через Telegram.");
      }
    } catch (error) {
      setError("Ошибка сети. Попробуйте позже.");
    }
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="container">
        <div className="left-section">
          <div className="logo">PAI</div>
          <div className='left-section-centered'>
            <h1>Учись вместе с ИИ</h1>
            <p>Практикуй не отходя от теории</p>
          </div>
        </div>

        <div className="right-section">
          <form className="registration-form" onSubmit={handleLogin}>
            <h2>Войти</h2>
            <p>Прокачай свои навыки!</p>
            {error && <div className="error-message-box">{error}</div>}

            <input
              type="text"
              placeholder="Твое имя"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Войти в аккаунт</button>

            <div className="google-login-container">
              <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
            </div>

            <div className="telegram-login-container" style={{ marginTop: '16px' }}>
              <LoginButton
                botUsername="pai_auth_bot" 
                onAuthCallback={handleTgSuccess}
                requestAccess="write"
                buttonSize="large"
              />
            </div>

            <p className="login-text">
              Нету аккаунта? <Link to="/registration">Зарегистрироваться</Link>
            </p>
          </form>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}

export default AuthLogin;
